import React from 'react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-12 px-4 md:pt-32 md:pb-16 text-center max-w-4xl mx-auto" data-id="element-65">
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-66">
        Equilibrio Hormonal Natural
      </h1>
      <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto font-medium" data-id="element-67">
        La guía práctica diseñada para ayudarte a entender cómo funciona tu
        sistema hormonal y cómo empezar a equilibrarlo de forma natural.
      </p>

      <div className="relative mx-auto max-w-md mb-10 cursor-pointer group" onClick={scrollToOffer} data-id="element-68">
        <div className="absolute inset-0 bg-brand-gold/20 blur-2xl rounded-full group-hover:bg-brand-gold/30 transition-all duration-500" data-id="element-69"></div>
        <img src="https://cdn.magicpatterns.com/uploads/npdBXfmVxUwmsE3EyXMgFs/0_cover_1.png" alt="Libro Equilibrio Hormonal Natural" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-70" />
      </div>

      <button onClick={scrollToOffer} className="w-full md:w-auto bg-brand-gold hover:bg-yellow-500 text-brand-green font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(212,168,67,0.4)] hover:shadow-[0_12px_25px_rgba(212,168,67,0.6)] transform hover:-translate-y-1 transition-all duration-300" data-id="element-71">
        QUIERO MI GUÍA AHORA
      </button>
    </section>;
}